export default __webpack_public_path__ + "static/media/element_spec_75.b3e196eb.webp";